export const YES_NO_OPTIONS = [
  { label: '是', value: 'true' },
  { label: '否', value: 'false' },
];
